"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isContentItemRail = exports.isRail = exports.isWatchVideoRail = void 0;
var _abstract_1 = require("./_abstract");
var isWatchVideoRail = function (component) {
    return component.type === _abstract_1.ComponentType.WatchVideoRail;
};
exports.isWatchVideoRail = isWatchVideoRail;
var isRail = function (component) {
    return component.type === _abstract_1.ComponentType.Rail;
};
exports.isRail = isRail;
var isContentItemRail = function (component) {
    return component.type === _abstract_1.ComponentType.ContentItemRail;
};
exports.isContentItemRail = isContentItemRail;
